export function htmlToPlainText(html: string): string {
  const withBreaks = html
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/h[1-6]>/gi, '\n\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<\/div>/gi, '\n');
  const container = document.createElement('div');
  container.innerHTML = withBreaks;
  return (container.textContent || container.innerText || '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
